import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DragescentState } from "../../../../store/reducers/stateType";
import { formatNumber, formatNumberForceSigned, getData } from "../../../../lib/commonFunctions";
import SubMenu from "../../../Menu/SubMenu";
import { GovernyInfo, Slot, Upgrade } from "../../../../lib/types";
import { portraits } from "../../../../assets/images/races";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";
import { UPGRADES } from "../../../../lib/enums";
import DialogButton from "../../../Common/DialogButton";
import { icons } from "../../../../assets/images/icons";

type OverviewRowData = {
  happiness: number;
  labyrinthAttempt: number;
  labyrinthAttemptLimit: number;
  population: {
    total: number;
    free: number;
  };
  resources: {
    gold: number;
    goldLimit: number;
    grain: number;
    grainLimit: number;
    grainMarket: number;
    food: number;
    stone: number;
    stoneLimit: number;
    stoneMarket: number;
    bricks: number;
    bricksLimit: number;
    bricksMarket: number;
    iron: number;
    ironLimit: number;
    ironMarket: number;
    weapons: number;
    weaponsLimit: number;
    weaponMarket: number;
    mana: number;
    manaLimit: number;
    manaMarket: number;
    energy: number;
    energyLimit: number;
    powerPoints: number;
  },
  buildings: Slot[];
}

const OutlinePalaceSubmenu = () => <SubMenu
  tabs={[
    {
      name: "AllianceOverview",
      title: "Overview",
      icon: "imperator",
      label: "Alliance",
      active: false,
      parameters: {
        reload: true
      }
    },
    {
      name: "GeneralsOverview",
      title: "Overview",
      icon: "imperator",
      label: "Generals",
      active: false,
      parameters: {
        reload: true
      }
    },
    {
      name: "DevelopmentOverview",
      title: "Overview",
      icon: "imperator",
      label: "Development",
      active: false,
      parameters: {
        reload: true
      }
    },
    {
      name: "OverviewPalace",
      title: "Overview",
      icon: "imperator",
      label: "Overview Palace",
      active: true,
      parameters: {
        reload: false
      }
    }
  ]}
/>

const ResourceCell = ({ value, limit, market }: any) => (<td className={limit < value + (market || 0) ? "negative" : "positive"}>
  {formatNumber(value)}
</td>);

const BuildingsCell = (buildings: Slot[]) => (<td className={"text-left"}>
  {buildings.map(b => <div
    className={b.turnsToBuilt || b.turnsToUpgrade ? "positive" : (b.damaged ? "negative" : "")}
    style={{ whiteSpace: "nowrap" }}
  >
    {`${b.type.name}${b.turnsToBuilt || b.turnsToUpgrade
      ? ` (${b.turnsToBuilt || b.turnsToUpgrade} TURNS)`
      : (b.damaged ? ` (${b.turnsToRepair} TURNS)` : "")}`}
  </div>)}
</td>);

const OverviewPalace = () => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const turn = useSelector((state: DragescentState) => state.governorate.turn);
  const emperor = useSelector((state: DragescentState) => state.governorate.alliance.emperor);
  const members = useSelector((state: DragescentState) => state.governorate.alliance.members);
  const outlinePalaceUpgrade = useSelector((state: DragescentState) => state
    .governorate.upgrades.find((u: Upgrade) => u.id === UPGRADES.OutlinePalace));
  const outlinePalace = useSelector((state: DragescentState) => state.governorate.outlinePalace);
  const credits = useSelector((state: DragescentState) => state.governorate.player.credits);

  const [data, setData] = useState<{[keys: string]: OverviewRowData} | null>(null);

  useEffect(() => {
    if (outlinePalace) {
      getData(`/api/overview/overviewPalace`)
        .then((overviewData) => {
          console.log(overviewData);
          setData(overviewData);
        });
    }
  }, [turn, outlinePalace]);

  if (!outlinePalace) {
    return <>
      <OutlinePalaceSubmenu />
        <div className="box">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="text-bigger">
                Outline palace allows you to see the details
                of governorates in your alliance and to quickly log into them.
              </div>
              <p>Outline palace not purchased</p>
              <DialogButton
                dialogOptions={{
                  name: "PurchaseUpgrade",
                  header: "Outline Palace",
                  id: UPGRADES.OutlinePalace,
                  params: {},
                  question: "Purchase Outline palace?",
                  purchasable: !(credits < outlinePalaceUpgrade.price),
                  price: outlinePalaceUpgrade.price
                }}
              >
                GET <img src={icons.credit} alt=""/>
              </DialogButton>
            </div>
          </div>
        </div>
      <span className="divider"/>
    </>
  }

  return (
    <>
      <OutlinePalaceSubmenu />
      <div className="box imp-overview" style={{ overflowX: "scroll" }}>
        {data && <table className={"table text-center table-hover"}>
          <thead>
          <tr>
            <th>Governorate</th>
            <th>Pops (free)</th>
            <th>Happiness</th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-obili`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-jidlo`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-kameni`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-infrastrukturni-body`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-zelezo`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-zbrane`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-mana`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-magie`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-zlato`} />
            </th>
            <th>
              <i className={`icon icon-standalone icon-sm icon-pozemky`} />
            </th>
            <th>Lab</th>
            <th>&nbsp;</th>
          </tr>
          </thead>
          <tbody>
          {members.map((member: GovernyInfo) => (
            <tr>
              <td className="no-padding-left text-left">
                <span>
                  <img width={37} height={37} src={portraits[member.race.name]} alt={"Race portrait"}/>
                </span>
                <span style={{ display: "inline-table", verticalAlign: "super" }}>
                    <GovernorateInfoLink
                      govId={member.id}
                      name={member.name}
                      raceName={member.race.name}
                    /><br/>
                  {member.commander && <i className={`icon icon-vojevudce icon-xs ${member.race.name}`}/>}
                  {emperor.id === member.id && <i className={`icon icon-imperator icon-xs ${member.race.name}`}/>}
                </span>
              </td>
              <td>{`${data[member.id].population.total} (${data[member.id].population.free})`}</td>
              <td>{data[member.id].happiness}</td>
              <ResourceCell
                value={data[member.id].resources.grain}
                market={data[member.id].resources.grainMarket}
                limit={data[member.id].resources.grainLimit} />
              <td className={data[member.id].resources.food < 0 ? "negative" : "positive"}>
                {formatNumberForceSigned(data[member.id].resources.food)}
              </td>
              <ResourceCell
                value={data[member.id].resources.stone}
                market={data[member.id].resources.stoneMarket}
                limit={data[member.id].resources.stoneLimit} />
              <ResourceCell
                value={data[member.id].resources.bricks}
                market={data[member.id].resources.bricksMarket}
                limit={data[member.id].resources.bricksLimit} />
              <ResourceCell
                value={data[member.id].resources.iron}
                market={data[member.id].resources.ironMarket}
                limit={data[member.id].resources.ironLimit} />
              <ResourceCell
                value={data[member.id].resources.weapons}
                market={data[member.id].resources.weaponMarket}
                limit={data[member.id].resources.weaponsLimit} />
              <ResourceCell
                value={data[member.id].resources.mana}
                market={data[member.id].resources.manaMarket}
                limit={data[member.id].resources.manaLimit} />
              <ResourceCell
                value={data[member.id].resources.energy}
                limit={data[member.id].resources.energyLimit} />
              <ResourceCell
                value={data[member.id].resources.gold}
                limit={data[member.id].resources.goldLimit} />
              <td>{data[member.id].resources.powerPoints}</td>
              <td>{data[member.id].labyrinthAttempt}/{data[member.id].labyrinthAttemptLimit}</td>
              <td>
                {member.id === id ? <>&nbsp;</>
                  : <a href={`${process.env.REACT_APP_API_URL}/alogin/${member.name}/react`} className={"btn btn-blank"}>
                  Log in
                </a>}
              </td>
            </tr>))
          }
          </tbody>
        </table>}
      </div>

      <div className="box imp-overview" style={{ overflowX: "scroll" }}>
        {data && <table className={"table text-center table-hover"}>
          <thead>
          <tr>
            {members.map((member: GovernyInfo) => (
              <td className="no-padding-left text-left">
                <span>
                  <img width={37} height={37} src={portraits[member.race.name]} alt={"Race portrait"}/>
                </span>
                <span style={{ display: "inline-table", verticalAlign: "super" }}>
                    <GovernorateInfoLink
                      govId={member.id}
                      name={member.name}
                      raceName={member.race.name}
                    /><br/>
                  {member.commander && <i className={`icon icon-vojevudce icon-xs ${member.race.name}`}/>}
                  {emperor.id === member.id && <i className={`icon icon-imperator icon-xs ${member.race.name}`}/>}
                </span>
              </td>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            {members
              .map((member: GovernyInfo) => BuildingsCell(data[member.id].buildings))}
          </tr>
          </tbody>
        </table>}
      </div>
    </>)
}

export default OverviewPalace;
